<template>
  <footer class="marketplace-footer mt-2xl py-2xl">
    <ul class="shop-sloan-footer-nav">
      <li>
        <span>&copy; Sloan Marketplace LLC</span>
      </li>
      <li>
        <a href="https://legal.sloan.com/#privacy-policy" target="_blank">{{ 'Privacy Policy' | t }}</a>
      </li>
      <li>
        <a href="https://legal.sloan.com/sloan-marketplace.html#terms-of-sale-sloan-marketplace-llc" target="_blank">
          {{ 'Terms of Sale' | t }}
        </a>
      </li>
      <li>
        <a href="https://legal.sloan.com/sloan-marketplace.html#terms-of-use" target="_blank">{{ 'Terms of Use' | t }}</a>
      </li>
    </ul>
  </footer>
</template>

<script>
import t from '../../main/i18n';

export default {
  name: 'MarketplaceFooter',
  filters: {
    t
  }
};
</script>

<style lang="scss" scoped>
@import '../../../scss/system';

.marketplace-footer {
  @media print {
    display: none;
  }
}

.shop-sloan-footer-nav {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  padding: 0;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 2.4rem;
  }

  a {
    color: #1f2937;

    &:hover {
      color: $color-blue-400;
    }
  }
}
</style>
